import { httpClient } from "./RestService";

export const send = async (message) => {
  return await httpClient().post("/v1/education/support", { message });
};
